import { USER_ROLE } from '../../../../core/services/users/profile.model';

export class User {
    _id: string;
    email: string;
    password: string;
    role: string;
    // profile: ProfileData;
    // company: string;
    blocked: boolean;

    constructor(user?) {
        user = user || {};
        this._id = user._id || null;
        this.email = user.email || null;
        this.password = user.password || null;
        this.role = user.role || USER_ROLE.ADMIN;
        // this.company = user.company || null;
        this.blocked = user.blocked || null;
    }
}



// WEBPACK FOOTER //
// /usr/app/src/app/main/content/app/user/user.model.ts